import React, { useState } from "react";
import Modal from "../modal/Modal";

import "./MarketInsightsUpload.css";
import { hasRoles } from "../../utils/roles";

import { MarketInsightsUploadModal } from "./MarketInsightsUploadModal";

export function MarketInsightsUpload(props) {
  const { setInsights, user } = props;

  let subLocation = determineSubLocation();

  const [modal, setModal] = useState(false);

  if (subLocation !== "categories") {
    return null;
  }

  if (!hasRoles(user.roles, ["Admin"])) {
    return null;
  }

  return (
    <div className="insights-control-panel-button-container">
      <button
        id="insight-upload-button"
        className="category-delete-button"
        onClick={() => {
          setModal(true);
        }}
      >
        <i className="fas fa-plus"></i>
      </button>
      <span className="tooltiptext">New Category</span>
      <Modal
        // Modal Props
        title={"Create New Category"}
        Component={MarketInsightsUploadModal}
        modal={modal}
        setModal={setModal}
        // Component Props
        setShow={setModal}
        setInsights={setInsights}
      />
    </div>
  );
}

function determineSubLocation() {
  const URL = window.location.href;

  return URL.substring(URL.lastIndexOf("/") + 1);
}
